import { BodyXsXs } from '@constants/text.ts';
import { TabContentInfoHeader } from '@routes/profile-bar/___shared___/styled.tsx';
import styled from 'styled-components';

export const TabHeaderWithTooltip = styled(TabContentInfoHeader)`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const ImportedByWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
`;

export const ImportedByEmail = styled(BodyXsXs)`
    color: var(--colors-text-on-disabled, #70768d);
    overflow-wrap: anywhere;
`;
